import { Controller } from "@hotwired/stimulus"

// Copies the text of a source input to the clipboard.
export default class extends Controller {
  static targets = ["source", "label"]

  async copy() {
    this.sourceTarget.select()
    try {
      await navigator.clipboard.writeText(this.sourceTarget.value)
      this.labelTarget.textContent = "Copied"
    } catch (_error) {
      this.labelTarget.textContent = "Press Ctrl/Cmd+C to copy"
    }
  }
}
